"use client"

import { Box, SxProps, Theme } from "@mui/material"
import { FC, PropsWithChildren } from "react"

interface Props extends PropsWithChildren {
    sx?: SxProps<Theme>
}

export const PageHeader: FC<Props> = ({ children, sx = {} }: Props) => {
    const style = {
        py: 8,
        mb: 2,
        ...sx,
    }
    return <Box sx={style}>{children}</Box>
}
